var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-container",
      attrs: {
        a_id: "forgot-password-container",
        "extension-name": "forgot-password"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "login-page-header",
          attrs: { a_id: "forgot-password-header" }
        },
        [
          _vm._v(
            _vm._s(
              _vm._f("translate")(
                "ForgotPasswordPage.ForgotPasswordHeaderStart"
              )
            )
          ),
          _c("br"),
          _vm._v(" "),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm._f("translate")(
                  "ForgotPasswordPage.ForgotPasswordHeaderEnd"
                )
              )
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "forgot-password-description",
          attrs: { a_id: "forgot-password-description" }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm._f("translate")(
                  "ForgotPasswordPage.ForgotPasswordDecription"
                )
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c("login-page-field", {
        attrs: {
          a_id: "forgot-password-field-email",
          title: _vm._f("translate")("ForgotPasswordPage.Email"),
          placeholder: _vm._f("translate")("ForgotPasswordPage.Email"),
          "image-type": "userName"
        },
        on: { enter: _vm.resetClicked },
        model: {
          value: _vm.email,
          callback: function($$v) {
            _vm.email = $$v
          },
          expression: "email"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "login-page-footer",
          attrs: { a_id: "forgot-password-footer" }
        },
        [
          _c(
            "a",
            {
              staticClass: "login-page-footer-link",
              attrs: { href: "#", a_id: "forgot-password-back-link" },
              on: { click: _vm.backButtonClicked }
            },
            [_vm._v(_vm._s(_vm._f("translate")("LoginPage.Backlink")))]
          ),
          _vm._v(" "),
          _vm.email
            ? _c(
                "button",
                {
                  staticClass: "login-page-footer-button-right",
                  attrs: { a_id: "forgot-password-reset-button" },
                  on: { click: _vm.resetClicked }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm._f("translate")("LoginPage.ResetPassword")) +
                      "\n\t\t"
                  )
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "login-page-footer-button-right",
                  attrs: {
                    disabled: "",
                    a_id: "forgot-password-reset-button-disabled"
                  },
                  on: { click: _vm.resetClicked }
                },
                [
                  _vm._v(
                    _vm._s(_vm._f("translate")("LoginPage.ResetPassword")) +
                      "\n\t\t"
                  )
                ]
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a55ea18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a55ea18","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/ForgotPasswordPage.vue
// module id = 446
// module chunks = 0